import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from "@danielmoncada/angular-datetime-picker";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { ModalHeaderComponentModule } from "../modal-header/modal-header.module";
import { ModalInputComponent } from "./modal-input.component";

export const MY_CUSTOM_FORMATS = {
  parseInput: "DD/MM/YYYY",
  fullPickerInput: "DD-MM-YYYY HH:mm",
  datePickerInput: "DD-MM-YYYY",
  timePickerInput: "HH:mm",
  monthYearLabel: "MMM-YYYY",
  dateA11yLabel: "LL",
  monthYearA11yLabel: "MMMM-YYYY",
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    RouterModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ModalHeaderComponentModule,
  ],

  declarations: [ModalInputComponent],
  exports: [ModalInputComponent],
})
export class ModalInputModule {}
